const authenticationInjectableFactory = ($injector) => {
  return $injector.get("authentication");
};

export const AuthenticationServiceProvider = {
  provide: "authentication",
  useFactory: authenticationInjectableFactory,
  deps: ["$injector"],
};
